import { useSelector } from 'react-redux'

import {
  ACTIONS_AND_TOTAL_COLUMNS,
  AWO_PMR_CHARGES_COLUMNS,
  AWO_PMR_SOAP_CHARGES_COLUMNS,
  CHARGES_COLUMNS,
  SOAP_CHARGES_COLUMNS,
  UNIT_AND_TOTAL_COLUMNS,
} from '~/components/common/Columns'
import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

export type ChargesColumnSubLabel = {
  label: string
}

export type SoapChargesColumn = {
  label: string
  width?: number
}

export type ChargesColumn = SoapChargesColumn & {
  id: number
  subLabels?: ChargesColumnSubLabel[]
}

export function useGetChargesColumns(isSoapCharges: false): ChargesColumn[]
export function useGetChargesColumns(isSoapCharges: true): SoapChargesColumn[]
export function useGetChargesColumns(
  isSoapCharges: boolean,
): ChargesColumn[] | SoapChargesColumn[] {
  const isAwoPmrRightRailEnabled = useSelector(
    getFeatureToggle(FeatureToggle.AWO_PMR_RIGHT_RAIL),
  )

  const isAwoChargesR5Epic5Enabled = useSelector(
    getFeatureToggle(FeatureToggle.AWO_CHARGES_R5_5),
  )

  const soapChargesColumns = isAwoPmrRightRailEnabled
    ? AWO_PMR_SOAP_CHARGES_COLUMNS
    : SOAP_CHARGES_COLUMNS
  const chargesColumns = isAwoPmrRightRailEnabled
    ? AWO_PMR_CHARGES_COLUMNS
    : CHARGES_COLUMNS

  const soapChargesR5Columns = isAwoChargesR5Epic5Enabled
    ? [...soapChargesColumns, ...ACTIONS_AND_TOTAL_COLUMNS]
    : [...soapChargesColumns, ...UNIT_AND_TOTAL_COLUMNS]

  const chargesR5Columns = isAwoChargesR5Epic5Enabled
    ? [...chargesColumns, ...ACTIONS_AND_TOTAL_COLUMNS]
    : [...chargesColumns, ...UNIT_AND_TOTAL_COLUMNS]

  return (isSoapCharges ? soapChargesR5Columns : chargesR5Columns) as
    | ChargesColumn[]
    | SoapChargesColumn[]
}
